import { render, staticRenderFns } from "./ReportDesktopGroupOrdered.vue?vue&type=template&id=65f36c42"
import script from "./ReportDesktopGroupOrdered.vue?vue&type=script&lang=js"
export * from "./ReportDesktopGroupOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports